// Types
import { type ObjectGraph } from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching';
import { type ContextMenuIntent } from './ContextMenuIntent';
import type { ContextMenuItem } from './types';
import type { ClassicalMenuItem } from '@jet-app/music-classical/api/types/context-menu';

// Jet
import { IntentKind } from '@jet-app/music-classical/intents';
import { requestViewPageWithQuery } from '@jet-app/music-classical/api/request-view-page';
import { NetworkError } from '@jet-app/music-classical/utilities';
import { requestPostAction } from '@jet-app/music-classical/api/request-post-action';

// Utils
import {
    transformToContextMenuItems,
    transformUserComponentsToContextMenuItems,
    type SectionWithMenuItems,
} from './transformContextMenuItems';

export const ContextMenuIntentController: IntentController<ContextMenuIntent> =
    {
        $intentKind: IntentKind.CONTEXT_MENU_INTENT,

        async perform(
            intent: ContextMenuIntent,
            objectGraph: ObjectGraph,
        ): Promise<ContextMenuItem[] | undefined> {
            const url = intent?.url;

            if (intent.actionType === 'perform') {
                const apiResponse = await requestPostAction(
                    url,
                    intent?.payload,
                    objectGraph,
                );

                if (!apiResponse?.body) {
                    throw NetworkError.noContent();
                }

                if (apiResponse.body.type === 'update-buttons') {
                    // Todo Handle buttons update
                }

                return {
                    type: apiResponse.body.type,
                } as unknown as ContextMenuItem[];
            } else {
                const apiResponse = await requestViewPageWithQuery(
                    url,
                    objectGraph,
                );

                if (!apiResponse?.body) {
                    throw NetworkError.noContent();
                }

                if (url.includes('user-components')) {
                    return transformUserComponentsToContextMenuItems(
                        apiResponse?.body
                            ?.secondaryButtons as ClassicalMenuItem[],
                        objectGraph,
                    );
                } else if (url.includes('tracksMetadata')) {
                    return transformUserComponentsToContextMenuItems(
                        apiResponse?.body as unknown as ClassicalMenuItem[],
                        objectGraph,
                    );
                } else {
                    return transformToContextMenuItems(
                        apiResponse?.body?.sections as SectionWithMenuItems[],
                        objectGraph,
                    );
                }
            }
        },
    };
